import React, { useEffect, useRef, useState } from 'react';
import styles from "./GoogleTranslate.module.scss";

const GoogleTranslate = () => {
    const googleTranslateRef = useRef(null);
    useEffect(() => {
        let intervalId;
        const checkGoogleTranslate = () => {
            new window.google.translate.TranslateElement(
                { 
                    pageLanguage: 'ru', 
                    includedLanguages: 'en,fr,de,ky,uz,ja,zh-CN,ko,it,ru', 
                    layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE 
                },
                googleTranslateRef.current
            );
        };
        intervalId = setInterval(checkGoogleTranslate, 100);
        return () => clearInterval(intervalId); // Очистка интервала при размонтировании
    }, []);

  return (
    <div className={styles.google_div_header}>
      {/* <h5 className={styles.google_div_header_h5}>Вы можете выбрать язык платформы:</h5> */}
      <div className={styles.google_translate_container} ref={googleTranslateRef}></div>
      
    </div>
  );
};

export default GoogleTranslate;
